const PING_INTERVAL = 3000;
const MAX_RECONNECT_DELAY = 30_000;

// AnyCable's own strategy has no ceiling, so a cable restart can leave a tab waiting hours.
export default function reconnectDelay(attempts) {
  let delay = PING_INTERVAL * 2 ** attempts;
  return Math.min(delay * (0.5 + Math.random()), MAX_RECONNECT_DELAY);
}
